import React from 'react';
import Table from "../../../../../../../../design/1/js/templates/molecules/table";
import TableBody from "../../../../../../../../design/1/js/templates/atoms/table-body";
import TableHeightRow from "../../../../../../../../design/1/js/templates/atoms/table-height-row";
import SavingPlanInfoTable from "../../../lib/savingPlan/SavingPlanInfoTable";
import {formatCurrency} from "../../../../../../../../design/1/js/lib/formatData";
import TableHead from "../../../../../../../../design/1/js/templates/atoms/table-head";
import TableColumnSize from "../../../lib/savingPlan/TableColumnSize";
import './index.scss';

interface SavingPlanTableSimulationDataProps {
    className?: string;
    simulationData: SavingPlanInfoTable;
    columnSize: TableColumnSize;
    shortBottomSpace?: boolean;
}

const SavingPlanTableSimulationData = ({
    className, simulationData, columnSize, shortBottomSpace = false,
}: SavingPlanTableSimulationDataProps) => {
    const baseClassName = 'w-simulationSavingPlanDataTable';
    const planCount = Math.max(simulationData.header.savingPlanLabels.length, 1);
    const {labelWidth, valueWidth} = getColumnWidths(columnSize, planCount);
    const hasFirstColLabel = (undefined !== simulationData.header?.labelFirstColumn);

    return (
        <div className={`${baseClassName} ${className}`}>
            <Table className={`${baseClassName}_simulationDataTable`} scrollable>
                <TableHead className={`${baseClassName}_simulationDataTableHead ${!hasFirstColLabel ? '-no-first-col-label' : ''}`}>
                    <div
                        className={`text-start`}
                        style={{flexBasis: `${labelWidth}%`, maxWidth: `${labelWidth}%`}}
                    >
                        {simulationData.header?.labelFirstColumn}
                    </div>
                    {simulationData.header.savingPlanLabels.map((label, index) => (
                        <div
                            key={`header-${index.toString()}`}
                            className={`text-end`}
                            style={{flexBasis: `${valueWidth}%`, maxWidth: `${valueWidth}%`}}
                        >
                            {label}
                        </div>
                    ))}
                </TableHead>
                <TableBody className={`${baseClassName}_tableBody`}>
                    {simulationData.value.map((data, index) => (
                        <TableHeightRow key={`row-${index.toString()}`} className={`${shortBottomSpace ? '-short-bottom-space' : ''}`}>
                            <div
                                className={`${baseClassName}__column`}
                                style={{flexBasis: `${labelWidth}%`, maxWidth: `${labelWidth}%`}}
                            >
                                {data.label}
                            </div>
                            {data.savingPlanValues.map((value, valueIndex) => (
                                <div
                                    key={`value-${index.toString()}-${valueIndex.toString()}`}
                                    className={`${baseClassName}__column text-end`}
                                    style={{flexBasis: `${valueWidth}%`, maxWidth: `${valueWidth}%`}}
                                >
                                    {formatCurrency(value)}
                                </div>
                            ))}
                        </TableHeightRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )
}

const getColumnWidths = (tableMode: TableColumnSize, planCount: number) => {
    if (tableMode === TableColumnSize.EQUAL) {
        const unitWidth = 100 / (planCount + 1);

        return {labelWidth: unitWidth, valueWidth: unitWidth};
    }

    const totalUnits = 3 + planCount;

    return {
        labelWidth: (3 / totalUnits) * 100,
        valueWidth: (1 / totalUnits) * 100,
    };
}

SavingPlanTableSimulationData.defaultProps = {
    className: '',
}

export default SavingPlanTableSimulationData;
